var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24ChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-chevron_down",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M6.718,6.708a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L.148,1.568a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L6,4.6l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z",
    transform: "translate(6.002 9.072)",
    fill: "#8d8ad3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24ChevronDown);
export default __webpack_public_path__ + "static/media/icon-24-chevron_down.b1d58fe803141e470b0853ed9e3378b2.svg";
export { ForwardRef as ReactComponent };